import { render, staticRenderFns } from "./ISAAbout.vue?vue&type=template&id=158b3ea4&scoped=true&"
import script from "./ISAAbout.vue?vue&type=script&lang=js&"
export * from "./ISAAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158b3ea4",
  null
  
)

export default component.exports